import { Component, OnInit } from '@angular/core';
import { NgForm} from '@angular/forms';
import { AuthService, WMAIApiService} from '../core/services';
import { WgisService } from '../wgis/wgis.service';
import { Angulartics2 } from 'angulartics2';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-activateuser',
  templateUrl: './activateuser.component.html',
})

export class ActivateUserComponent implements OnInit {

  paramsSubscription: any;
  id: number;
  uuid: string;
  activationError = false;
  activationSuccess = false;

  constructor(
    private auth: AuthService,
    private wgisservice: WgisService,
    private angulartics2: Angulartics2,
    private wmaiservice: WMAIApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { 
    this.wgisservice.setMapInvisible();
  }

  ngOnInit() {
    this.paramsSubscription = this.activatedRoute.params.subscribe((param: any) => {
      this.id = param['id'];
      this.uuid = param['uuid'];
      if (this.id != null && this.uuid != null) {
        this.wmaiservice.activateUser(this.id, this.uuid).subscribe((data) => {
            if (data != null) {
              if (data[0] != null) {
                this.activationSuccess = true;
                this.router.navigate(['/home']);
              } else {
                this.activationError = true;
              }
            } else {
              this.activationError = true;
            }
        });
      }
    });
  }
}
